/*eslint-disable */
const $ = window.jQuery = require('jquery');
import audioPlay from '../../assets/audio/piano.mp3';
var checkNotficationInterval;
import {
  bus
} from '../../main';
export default {
  name: 'lymphomap-header',
  components: {},
  props: [],
  data () {
    return {
      showBtn:true,
      is_superuser:Boolean,
      is_admin:Boolean,
      NotificationMsg:'',
      connectionRequest:'',
      connectionRequestCheck:'',
      NotificationMsgCheck: '',
      supportNotificationMsg:'',
      supportNotificationMsgCheck:'',
    }
  },
  computed: {

  },
  mounted () {
    bus.$on('showHeaderbtn', (data) => {
      this.showBtn = data;
    });
    bus.$on('userFriendRequest', (data) => {
      this.$store.dispatch('chatBroserNotificationFun').then((response)=>{
        this.connectionRequestCheck = response.data.data.connection_request;
      });
    });
    bus.$on('userFriendRequestClear', (data) => {
      this.connectionRequestCheck = 0;
    });

    bus.$on('updateMessageNotifications', (data) => {
      if(window.location.pathname.indexOf('chat') == -1) {
        this.NotificationMsgCheck = data.totalUnreadCount;
      }
    });
    bus.$on('clearMessageNotifications', (data) => {
      this.NotificationMsgCheck = 0;
    });


    this.$store.dispatch('getAcUserDetailsFun').then((res)=>{
      this.is_superuser = res.data.data.is_superuser
      this.is_admin = res.data.data.is_admin
    })
    this.chatBrowserNotificationFunction()
    // checkNotficationInterval = setInterval(() => {
    //   if(localStorage.getItem('token')){
    //    this.chatBrowserNotificationFunction()
    //  }else{
    //     clearInterval(checkNotficationInterval)
    //   }
    // },2000);
  },
  methods: {
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    chatBrowserNotificationFunction(){
      this.connectionRequest = ''
      this.$store.dispatch('chatBroserNotificationFun').then((res)=>{
        this.NotificationMsg = res.data.data.message
        this.connectionRequest = res.data.data.connection_request
        bus.$emit('connectionRequestBus', this.connectionRequest);
        this.supportNotificationMsg = res.data.data.support_message
        if(this.connectionRequestCheck != ''){
          this.connectionRequestCheck =  res.data.data.connection_request
        }else{
          this.connectionRequestCheck = ''
        }
        if(this.NotificationMsgCheck != ''){
          this.NotificationMsgCheck =  res.data.data.message
        }else{
          this.NotificationMsgCheck = ''
        }
        if(this.supportNotificationMsgCheck != ''){
          this.supportNotificationMsgCheck =  res.data.data.support_message
        }else{
          this.supportNotificationMsgCheck = ''
        }
        if(this.NotificationMsg != undefined && (this.NotificationMsg != this.NotificationMsgCheck)){
          this.NotificationMsgCheck = this.NotificationMsg
          this.playSound(audioPlay)
        }
        if(this.connectionRequest != undefined && (this.connectionRequest != this.connectionRequestCheck)){
          this.connectionRequestCheck = this.connectionRequest
          // this.playSound(audioPlay)
        }
        if(this.supportNotificationMsg != undefined && (this.supportNotificationMsg != this.supportNotificationMsgCheck)){
          this.supportNotificationMsgCheck = this.supportNotificationMsg
          // this.playSound(audioPlay)
        }
        if(this.connectionRequestCheck){
          bus.$emit('connectionRequestBus', this.connectionRequestCheck);
        }else{
          bus.$emit('connectionRequestBus', '');
        }
        if(this.supportNotificationMsgCheck){
          localStorage.setItem('SupportMsg', this.supportNotificationMsgCheck)
        }else{
          localStorage.removeItem('SupportMsg')
        }
        // console.log(res.data, "Chat Notification Log")
      }).catch((err)=>{
      })
     },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      let covid_19_popup = document.querySelector(".covid_19_popup");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
        if(covid_19_popup){
          covid_19_popup.classList.add('d-none');
        }
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
          if(covid_19_popup){
          covid_19_popup.classList.remove('d-none');
          }
        }
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logout')
      .then(() => {
        this.logOutUser()
        ///this.$router.push('/')
        window.location.href = '/';
      })
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
